import React from "react";
import SmartOnlineLink from "./SmartOnlineLink";
import Store from "./../../../content/Store";
import Contentify from "../../../content/Contentify";

export const AskAMedicalExpertLink = (props) => {
  let { linkText, pathTo, iconName,id } = props.content;
  if(props.featureFlagEP === true){
    pathTo=props.url;
  }
  return (
    <>
    {props.featureFlagEP === true ?
    <SmartOnlineLink linkText={linkText} pathTo={pathTo} iconName={iconName} 
        isExternalLink={true} 
        isDisabled={props.isDisabled}
        disableStyle={props.disableStyle}
        id = {id}/>:
    <SmartOnlineLink linkText={linkText} pathTo={pathTo} iconName={iconName} isExternalLink={false}id = {id}/>}
    </>
  );
};

AskAMedicalExpertLink.content = Store.AskAMedicalExpertSmartLink;

export default Contentify(AskAMedicalExpertLink);
